module.exports = __webpack_public_path__ + "img/credit-card-new-payment-successful-svgrepo-com.c2ce003d.svg";